import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vuex from 'vuex'
import store from './vuex/index'
import getRJPageSize from './common/utils'
import { utilHelp as help } from './common/help'
import './directives/directives'
import App from './App'
import './assets/css/index.css'
import Print from './common/myPrint'
Vue.use(Print)
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.prototype.EventBus = new Vue()
Vue.config.productionTip = false
Vue.prototype.getRJPageSize = getRJPageSize
Vue.prototype.fileDownload = help.fileDownload
Vue.prototype.getQueryString = function (name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  };
  return null
}
Vue.prototype.$dateFormat = function (date, format) {
  var args = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(format)) { format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (var i in args) {
    var n = args[i]
    if (new RegExp('(' + i + ')').test(format)) { format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? n : ('00' + n).substr(('' + n).length)) }
  }
  return format
}
router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    next()
  } else {
    let fusrno = localStorage.getItem('fUserNo')
    if (typeof fusrno === 'undefined' || fusrno == null || fusrno === '') {
      next({ path: '/Login' })
    }
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js